








import { Component, Vue } from "vue-property-decorator";
import i18n from '@/plugins/i18n';

@Component({
  components: {}
})
export default class TermsAndPolicyError extends Vue {}
